import React, { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';
import {
  BlogSortBy,
  ProposalsSortBy,
  SortBy,
  SortDirection
} from 'src/api/types';
import useGTAG, { GTAGPrefix } from 'src/hooks/useGTAG';
import Item from './Item';
import { sortOptionList } from './constants';

interface Props {
  className?: string;
  gtagPrefix?: GTAGPrefix;
  proposalsSortList: (SortBy | ProposalsSortBy | BlogSortBy)[];
  selectedProposalsSort: {
    sortBy?: SortBy | ProposalsSortBy | BlogSortBy;
    sortDirection?: SortDirection;
  };
  onProposalsSortChange: (sortProps: {
    sortDirection: string;
    sortBy: string;
  }) => void;
}

const SortList: FC<Props> = ({
  proposalsSortList,
  selectedProposalsSort: { sortBy = null, sortDirection = null } = {},
  onProposalsSortChange,
  gtagPrefix
}) => {
  const intl = useIntl();
  const { trackGtagEvent } = useGTAG();
  const sortList = useMemo(() => {
    return Object.keys(sortOptionList).reduce((acc, optionName) => {
      const option = proposalsSortList?.find((item) =>
        optionName.toLowerCase()?.includes(item.toLowerCase())
      );
      if (option) {
        return {
          ...acc,
          [optionName.toLowerCase()]: sortOptionList[optionName]
        };
      }
      return acc;
    }, {});
  }, [proposalsSortList]);

  const handleSortingChange = (value: string) => {
    const [selectedSortBy, selectedSortDirection] = value.split('_');
    onProposalsSortChange({
      sortBy: selectedSortBy,
      sortDirection: selectedSortDirection
    });
    trackGtagEvent(`${gtagPrefix}_sort_choose`, value, 'sort_type');
  };

  return (
    <>
      {Object.keys(sortList)?.length
        ? Object.keys(sortList).map((key) => (
            <button
              key={key}
              className="w-full"
              onClick={() => handleSortingChange(sortList[key].id)}
            >
              <Item
                {...sortList[key]}
                title={intl.formatMessage(sortList[key].title)}
                selected={
                  key.toLowerCase() ===
                  `${sortBy}_${sortDirection}`.toLowerCase()
                }
              />
            </button>
          ))
        : null}
    </>
  );
};

export default SortList;
